module.exports = __webpack_public_path__ + "static/media/nft-dev-img1.48987dc7.svg";